const settingsEnglish = {
  header: {
    title: "LinkedIn Settings",
    description: "Connect your LinkedIn account to access the system",
    descriptionEmployee: "Connect your accounts to get started"
  },
  messages: {
    success: "Success!",
    error: "An error occurred",
    closeButton: "Close"
  },
  linkedin: {
    title: "LinkedIn Profile",
    loading: "Loading...",
    connected: "LinkedIn profile connected",
    description: "Connect your LinkedIn profile to create posts",
    connectButton: "Connect LinkedIn",
    disconnectButton: "Disconnect LinkedIn",
    profileInfo: {
      unnamed: "Unnamed user",
      status: "Status:",
      active: "Active",
      expires: "Expires:",
      expiresIn: "In {days} days",
      unknown: "Unknown",
      noProfileData: "Could not retrieve profile data. Try disconnecting and connecting again."
    }
  },
  telegram: {
    title: "Telegram Bot",
    description: "Connect Telegram to generate and receive LinkedIn posts directly",
    connected: "Telegram is connected",
    connectButton: "Connect Telegram",
    disconnectButton: "Disconnect Telegram",
    generating: "Generating code...",
    connectionGuide: {
      title: "How to connect your Telegram",
      steps: [
        "Open Telegram and search for NuvikAI_bot",
        "Start the bot by typing /start",
        "Send this code to the bot:"
      ],
      expires: "The code expires in 15 minutes"
    }
  },
  deliverySettings: {
    title: "Delivery Settings",
    description: "Choose where to receive your weekly AI-generated LinkedIn posts",
    options: {
      website: "On the website",
      telegram: "Via Telegram"
    },
    helpText: {
      website: "Your posts will be displayed in the \"LinkedIn AI Generator\" section of the app.",
      telegram: "Your posts will be sent directly to you via Telegram."
    }
  },
  readyCard: {
    title: "All set!",
    description: "You can now use Telegram to generate and publish LinkedIn posts, or view your generated posts directly in the app.",
    viewPostsButton: "View your posts"
  },
  customerSuccess: {
    title: "LinkedIn account connected!",
    description: "Your LinkedIn account is now connected. You will now receive content from the system which will be shared on your LinkedIn profile."
  },
  language: {
    title: "Language",
    description: "Choose your preferred language"
  }
};

export default settingsEnglish; 